import { createScopedEvent } from 'chimera/all/plugins/tracking/google/events/analytics/index'

/**
 * @param {object} Vue
 * @param {object} event
 * @param {object} event.scope
 */
export function trackReachedContactForm(Vue, { scope } = {}) {
  Vue.$gtag.event('reached_contact_form', createScopedEvent(scope))
}
